import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import WarrantyStandardForm from './WarrantyStandardForm';

export default props => {
  const warrantyStandardStore = ReactOnRails.getStore('warrantyStandardStore');

  return (
    <Provider store={warrantyStandardStore}>
      <WarrantyStandardForm {...props} />
    </Provider>
  );
};
